/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Js_CoreInputs */

const en_svchip_js_core = /** @type {(inputs: Svchip_Js_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JS core`)
};

const ar_svchip_js_core = /** @type {(inputs: Svchip_Js_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نواة جافاسكريبت`)
};

const bn_svchip_js_core = /** @type {(inputs: Svchip_Js_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JS কোর`)
};

const de_svchip_js_core = /** @type {(inputs: Svchip_Js_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JS-Kern`)
};

const es_svchip_js_core = /** @type {(inputs: Svchip_Js_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Núcleo JS`)
};

const fr_svchip_js_core = /** @type {(inputs: Svchip_Js_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noyau JS`)
};

const pt_svchip_js_core = /** @type {(inputs: Svchip_Js_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Núcleo JS`)
};

const zh_svchip_js_core = /** @type {(inputs: Svchip_Js_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JS 核心`)
};

const tr_svchip_js_core = /** @type {(inputs: Svchip_Js_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JS çekirdeği`)
};

const ru_svchip_js_core = /** @type {(inputs: Svchip_Js_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ядро JS`)
};

const pl_svchip_js_core = /** @type {(inputs: Svchip_Js_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rdzeń JS`)
};

/**
* | output |
* | --- |
* | "JS core" |
*
* @param {Svchip_Js_CoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_js_core = /** @type {((inputs?: Svchip_Js_CoreInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Js_CoreInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_js_core(inputs)
	if (locale === "bn") return bn_svchip_js_core(inputs)
	if (locale === "de") return de_svchip_js_core(inputs)
	if (locale === "es") return es_svchip_js_core(inputs)
	if (locale === "fr") return fr_svchip_js_core(inputs)
	if (locale === "pt") return pt_svchip_js_core(inputs)
	if (locale === "zh") return zh_svchip_js_core(inputs)
	if (locale === "tr") return tr_svchip_js_core(inputs)
	if (locale === "ru") return ru_svchip_js_core(inputs)
	if (locale === "pl") return pl_svchip_js_core(inputs)
	return en_svchip_js_core(inputs)
});